import React from 'react';

export default function HashLink(
    props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
) {
    return (
        <a
            {...props}
            href="#1"
            onClick={ev => {
                ev.preventDefault();
                props.onClick?.(ev);
            }}>
            {props.children}
        </a>
    );
}
